import { useMemo } from "react";
import { useMediaQuery } from "react-responsive";

const maxWidthCheckKeys = ["mobileOnly"];
export const breakpoints = {
  mobileOnly: 480,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1200,
};

type BreakpointType = keyof typeof breakpoints;

const useMediaQueryBreakpoint = (value: number, key = "min-width") =>
  // biome-ignore lint/correctness/useHookAtTopLevel: skip
  useMediaQuery({ query: `(${key}: ${value}px)` });

export const useBreakpoints = () => {
  const breakpointMediaQueries = Object.entries(breakpoints).reduce(
    (acc, [key, value]) => ({
      ...acc,
      // biome-ignore lint/correctness/useHookAtTopLevel: skip
      [key]: useMediaQueryBreakpoint(
        value,
        maxWidthCheckKeys.includes(key) ? "max-width" : "min-width",
      ),
    }),
    {} as Record<BreakpointType, boolean>,
  );

  return useMemo(
    () => ({
      ...breakpointMediaQueries,
      width: window.innerWidth,
      height: window.innerHeight,
    }),
    [breakpointMediaQueries],
  );
};
